import { ActionInterface } from './MessageTypePayloads'
import { SenderOrRecipient, MessageInterface, MessageType } from '../MessageInterface'
import { createBaseMessage } from '../MessageCreation'

export enum MediaPayloadMediaType {
  Image = 'image',
  Video = 'video'
}
/**
 * @tsoaModel
 */
export interface MediaPayload {
  mediaType: MediaPayloadMediaType
  mediaURL: string
}

export function isMediaPayload(payload: any): payload is MediaPayload {
  return (
    payload !== undefined &&
    (payload as MediaPayload).mediaURL !== undefined &&
    (payload as MediaPayload).mediaType !== undefined &&
    ((payload as MediaPayload).mediaType === MediaPayloadMediaType.Image ||
      (payload as MediaPayload).mediaType === MediaPayloadMediaType.Video)
  )
}
export function createMediaMessage(
  to: SenderOrRecipient,
  from: SenderOrRecipient,
  mediaType: MediaPayloadMediaType,
  mediaURL: string
): MessageInterface {
  return createBaseMessage(
    MessageType.Media,
    { mediaType: mediaType, mediaURL: mediaURL },
    to,
    from
  )
}
